document.addEventListener("DOMContentLoaded", () => {
  const videosCarousel = document.querySelectorAll(".what-to-expect-slider");

  videosCarousel.forEach(videoCarousel => {
    let isInViewport = false;

    const slider = new Splide(videoCarousel, {
      type: 'slide',
      rewind: true,
      pagination: true,
      arrows: true,
      perPage: 4,
      gap: 24,
      trimSpace: false,
      breakpoints: {
        1024: { perPage: 3, gap: 16 },
        990: { perPage: 2, gap: 16 },
        767: { perPage: 1, gap: 16, padding: { right: '4rem' } }
      }
    });

    const syncVideos = () => {
      slider.Components.Elements.slides.forEach(slideEl => {
        const video = slideEl.querySelector('video');
        if (!video) return;

        if (isInViewport && slideEl.classList.contains('is-visible')) {
          if (video.paused) video.play().catch(() => {});
        } else {
          if (!video.paused) video.pause();
        }
      });
    };

    slider.on('mounted moved', () => {
      requestAnimationFrame(syncVideos);
    });

    slider.mount();

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        isInViewport = entry.isIntersecting;
        syncVideos();
      });
    }, { threshold: 0.2 });

    observer.observe(videoCarousel);
  });
});